export default __webpack_public_path__ + "static/media/shape-48.ce7e74eb.png";